export default __webpack_public_path__ + "static/media/why_tequip_logo.e42f1235.png";